import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  display: grid;
  justify-items: center;
  grid-gap: 12px;

  border: none;
  cursor: pointer;
  padding: 22px 8px;
  transition: 0.3s;

  line-height: 14px;
  font-weight: 500;
  width: 100px;
  height: 100px;
  background-color: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);

  :hover {
    color: var(--primary, #00a89c);
    transform: scale(1.1);
    background-color: #eee;
  }
`;

export default function ButtonGrupo({
  id,
  onClick,
  icon,
  iconAlt,
  grupo,
}) {
  return (
    <Button id={id} onClick={onClick}>
      <img src={icon} alt={iconAlt} />
      <p>{grupo}</p>
    </Button>
  );
}
